



























import Vue from 'vue';

export default Vue.extend({
	data() {
		return {
			headerFixed: false,
			toggle: false,
			menuList: [
				{
					name: 'aboutUs',
					href: '#about',
				},
				{
					name: 'services',
					href: '#services',
				},
				// {
				// 	name: 'support',
				// 	href: '#support',
				// },
				{
					name: 'contact',
					href: '#contact',
				},
			],
			languageList: [
				{
					name: 'English',
					value: 'en',
				},
				{
					name: '繁體中文',
					value: 'tw',
				},
			],
		};
	},
	created() {
		window.addEventListener('scroll', this.handleScroll);
		this.handleScroll();
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		onToggle() {
			this.toggle = !this.toggle;
		},
		handleScroll() {
			if (window.pageYOffset > 20) {
				this.headerFixed = true;
			} else {
				this.headerFixed = false;
			}
		},
		changeLang(val: string) {
			this.$i18n.locale = val;
			this.toggle = false;
		},
		pageClick() {
			this.toggle = false;
		},
	},
});
